module.exports = __webpack_public_path__ + "static/media/ic_error.a63c427c.png";